import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BorrowingHeader from '../../shared/BorrowingHeader';
import BorrowingEmptyContentPanel from '../../shared/BorrowingEmptyContentPanel';
import { Fees, Abacus } from '@bibliocommons/base-icons';

export default function FinesEmptyContentPanel({ fetching }) {
  const icon = fetching ? <Abacus /> : <Fees />;
  return (
    <div className="cp-fines">
      <div className="title-row">
        <BorrowingHeader
          headingKey="section_title_fines"
          taglineKey="section_tagline_fines"
          helpLinkPage="005borrowing/010fines" />
        <BorrowingEmptyContentPanel
          className="cp-recentlyreturned-empty-content-panel"
          fetching={fetching}
          showStaffPicksLink={false}
          helpPage="040settings/005privacy-settings"
          icon={icon}
          title={<FormattedMessage id="empty_fines" />} />
      </div>
    </div>
  );
}

FinesEmptyContentPanel.propTypes = {
  fetching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FinesEmptyContentPanel/FinesEmptyContentPanel.jsx